let ContentfulConfig = {
    space: 'mzij3xo7fi1p',
    accessToken: 'rjrmXcp_tc2Rrxkw40D6Lig84t3cQMcK6mb-sufbfPU'
};

export default ContentfulConfig;